// CRM i18n singleton.
//
// Merges the `shared` catalog from @govard/i18n-core with the app-local `crm`
// namespace. Phase 1 is ru-only; the fallback locale is `en` for when the
// shared catalog adds keys the ru catalog has not caught up to yet.
//
// TODO [PHASE-2]: add an `en` catalog for the CRM namespace once we ship the
// English UI and drive the locale from user settings.

import { createI18n, ruShared, type I18n, type NamespaceMap } from '@govard/i18n-core';

import { crmRu } from './ru/crm.js';

const namespaces: NamespaceMap = {
  ...ruShared,
  crm: crmRu,
};

export const i18n: I18n = createI18n({
  locale: 'ru',
  fallbackLocale: 'en',
  namespaces,
  onMissing: 'warn',
});
